
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="bg-manuscript-primary text-white py-6 mt-12">
      <div className="container mx-auto text-center">
        <ul className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4">
          <li><Link to="/terms" className="hover:text-white/70 transition-colors">Terms & Conditions</Link></li>
          <li><Link to="/privacy" className="hover:text-white/70 transition-colors">Privacy Policy</Link></li>
          <li><Link to="/contact" className="hover:text-white/70 transition-colors">Contact Us</Link></li>
        </ul>
        <p className="text-sm mt-4 text-white/70">&copy; {new Date().getFullYear()} UnitCodex. All rights reserved.</p>
      </div>
    </footer>
  );
}
